const SPACINGS: { [key: number]: string } = {
  2: '2px',
  4: '4px',
  6: '6px',
  8: '8px',
  10: '10px',
  12: '12px',
  14: '14px',
  16: '16px',
  24: '24px',
  32: '32px',
  40: '40px',
};

export default SPACINGS;
